import { type PropsWithChildren } from "react";
import { Stacker } from "~/common/components/Stacker/Stacker";

export interface GridGappedContainerProps {
  className?: string;
  gapSize?: GridGappedContainerSize;
  direction?: GridGappedContainerDirection;
}

export enum GridGappedContainerDirection {
  ROW = "row",
  COLUMN = "column",
}

export enum GridGappedContainerSize {
  S_4 = 4,
  S_10 = 10,
  S_16 = 16,
  S_20 = 20,
  S_24 = 24,
  S_32 = 32,
}

/**
 * @deprecated - prefer to use css with display flex + gap property
 * @param props
 * @constructor
 */
const GridGappedContainer = (props: PropsWithChildren<GridGappedContainerProps>) => {
  const {
    gapSize = GridGappedContainerSize.S_4,
    direction = GridGappedContainerDirection.ROW,
    children,
    className,
  } = props;

  return (
    <Stacker gap={gapSize} direction={direction} className={className}>
      {children}
    </Stacker>
  );
};

export default GridGappedContainer;
